export default {
  primary: '#9248F9',
  secondary: '#0067FF',
  titleHeader: '#a6a6a6',
  accent: '#82B1FF',
  error: '#FF3868',
  info: '#9248F9',
  success: '#625FFC',
  warning: '#FF6400',
  background: '#292930'
}
